import { PyrocastLog } from "../../interfaces/pyrocast-log.interface";
import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject, Observable, of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { PyrocastLogsService } from "../pyrocast-logs.service";
import { Injectable, inject } from "@angular/core";

@Injectable()
export class PyrocastLogsDataSource implements DataSource<PyrocastLog> {

    private pyrocastLogsService = inject(PyrocastLogsService);

    private pyrocastLogsSubject = new BehaviorSubject<PyrocastLog[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private countSubject = new BehaviorSubject<number>(0);
    public currentPageCountSubject = new BehaviorSubject<number>(0);

    public loading$ = this.loadingSubject.asObservable();
    public count$ = this.countSubject.asObservable();
    public currentPageCount$ = this.currentPageCountSubject.asObservable();

    constructor() { }

    connect(collectionViewer: CollectionViewer): Observable<PyrocastLog[]> {
        return this.pyrocastLogsSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.pyrocastLogsSubject.complete();
        this.loadingSubject.complete();
        this.countSubject.complete();
        this.currentPageCountSubject.complete();
    }

    list(filters = {}, orderBy = '', order = 'asc', pageNumber = 0, pageSize = 25) {

    this.loadingSubject.next(true);

    this.pyrocastLogsService.index(filters, orderBy, order, pageNumber, pageSize)
        .pipe(
            catchError((error) => {
                console.error("=== ❌ Error Occurred ===", error);
                this.loadingSubject.next(false);
                return of([]);
            })
        )
        .subscribe(response => {
            this.loadingSubject.next(false); 

            if (response && Array.isArray(response) && response.length > 0) {
                
                
                const totalRecords = response.length;

                
                const actualPage = (pageNumber === 1) ? 0 : (pageNumber > 1 ? pageNumber - 1 : 0);
                const startIndex = actualPage * pageSize;
                const endIndex = startIndex + pageSize;
                
                
                const rawPaginatedData = response.slice(startIndex, endIndex);

                
                const paginatedData = rawPaginatedData.map(item => {
                    const key = Object.keys(item)[0]; 
                    const innerData = item[key] || {};

                    let deviceName = '';

                    if (innerData.OperatorCalls) {
                        const firstEvent: any = Object.values(innerData.OperatorCalls)[0];
                        if (firstEvent?.deviceName) deviceName = firstEvent.deviceName;
                    } 
                    else if (innerData.Downloads) {
                        const firstDateObj: any = Object.values(innerData.Downloads)[0];
                        if (firstDateObj) {
                            const firstUuidLog: any = Object.values(firstDateObj)[0];
                            if (firstUuidLog?.device) deviceName = firstUuidLog.device;
                        }
                    }

                    return {
                        id: key,                             
                        name: deviceName, 
                        ...innerData
                    };
                });

            
                this.pyrocastLogsSubject.next(paginatedData);
                this.countSubject.next(totalRecords); 
                this.currentPageCountSubject.next(paginatedData.length);

            } else {
                this.clearDataSource();
            }
        });
}


    // list(filters = {}, orderBy = '', order = 'asc',
    // 			 pageNumber = 0, pageSize = 5) {

    // 		this.loadingSubject.next(true);

    // 		this.pyrocastLogsService.index(filters, orderBy, order,
    // 			pageNumber, pageSize).pipe(
    // 			catchError(() => of([])),
    // 			finalize(() => this.loadingSubject.next(false))
    // 		)
    // 			.subscribe(response => {
    // 				this.pyrocastLogsSubject.next(response);
    // 				this.countSubject.next(response.total);
    // 				this.currentPageCountSubject.next(response.length);
    // 			});
    // 	}

    private clearDataSource() {
        this.pyrocastLogsSubject.next([]);
        this.countSubject.next(0);
        this.currentPageCountSubject.next(0);
        this.loadingSubject.next(false);
    }

    getList() {
        return this.pyrocastLogsSubject.value;
    }
}